<template>
  <div id="ticket-verify" class="container">
    <a-page-header class="header" :title="serviceConfig?.title || '客票验真'" />
    <div class="mod-wrap">
      <div class="block form">
        <a-form
          :form="form"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-form-item label="旅客姓名">
            <a-input
              placeholder="请输入您客票上显示的姓名"
              v-decorator="[
                'passengerName',
                {
                  rules: [
                    {
                      validator: handleFieldValidate,
                    },
                  ],
                  validateTrigger: 'blur',
                },
              ]"
              size="large"
            />
          </a-form-item>
          <a-form-item label="票号">
            <a-input
              :placeholder="`请输入13位票号，格式:${ticketCode}-XXXXXXXXXX`"
              v-decorator="[
                'ticketNo',
                {
                  rules: [
                    {
                      validator: handleFieldValidate,
                    },
                  ],
                  validateTrigger: 'blur',
                },
              ]"
              size="large"
            />
          </a-form-item>
          <a-form-item label="验证码">
            <l8-imgcaptcha
              ref="imgcaptcha"
              v-decorator="[
                'captcha',
                {
                  rules: [{ validator: handleFieldValidate }],
                  validateTrigger: 'blur',
                },
              ]"
              size="large"
              @blur="onCaptchaChange"
            ></l8-imgcaptcha>
          </a-form-item>
          <a-form-item label :wrapper-col="{ span: 16, offset: 6 }">
            <a-button
              type="primary"
              class="submit-btn"
              size="large"
              @click="formSubmit"
              >查询</a-button
            >
          </a-form-item>
        </a-form>
      </div>
      <div
        class="block ticket-verify-notice"
        v-if="ticketVerifyTips"
        v-html="ticketVerifyTips"
      ></div>
    </div>
    <div class="table-wrap" v-if="isSearch">
      <a-spin class="loading" v-if="loading" tip="查询中..." />
      <div v-else v-show="list.length > 0">
        <div class="table-head">电子客票信息</div>
        <template v-for="item in list">
          <a-descriptions
            bordered
            :column="{ xxl: 4, xl: 4, lg: 4, md: 4, sm: 2, xs: 1 }"
            :key="item.tickNo"
          >
            <a-descriptions-item label="电子客票票号" :span="2">
              {{ item.issCode + '-' + item.tickNo  }}
            </a-descriptions-item>
            <a-descriptions-item label="旅客姓名" :span="2">
              {{ item.passengerName }}
            </a-descriptions-item>
            <a-descriptions-item :span="4">
              <template v-slot:label></template>
              <p class="result">经验证，客票信息正确</p>
            </a-descriptions-item>
          </a-descriptions>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { validate } from '@/assets/js/validate'
import getAppInfo from '@/utils/from'
import { queryTicketInfo } from '@/apis/invoice'
import './index'

export default {
  data () {
    return {
      form: this.$form.createForm(this),
      phoneCaptcha: false, // 校验结果
      ticketCode: getAppInfo()?.ticketCode,
      list: [],
      segment: [],
      ticketVerifyTips: '',
      loading: false,
      isSearch: false,
      serviceConfig: {}
    }
  },
  created () {
    this.getCmsData()
    window.__MICRO_ROOT__?.api?.track?.('ticketcheck_view')
  },
  methods: {
    async getCmsData () {
      try {
        const res = await window.__MICRO_ROOT__?.cms?.getPageData()
        if (res) {
          const { content } = res?.ticketVerifyTips || {}
          const { services } = res['web-services-config'] || []
          const pagePath = window.location.pathname
          this.serviceConfig = services?.find(item => pagePath.indexOf(item.key) >= 0) || null
          this.ticketVerifyTips = content || ''
          // 服务开关
          if (this.serviceConfig && !this.serviceConfig?.switchStatus) {
            this.$message.error(
              '抱歉，找不到服务，即将返回首页',
              () => { this.$router.replace('/') }
            )
          }
        }
      } catch (err) {
        console.error('Error fetching CMS data:', err)
      }
    },
    onCaptchaChange (value) {
      this.phoneCaptcha = !!value
    },
    handleFieldValidate (rule, value, callback) {
      const formValues = this.form.getFieldsValue()
      formValues.idType = 'TICKETNO'
      validate('invoice-valid', formValues, rule.fullField).then(
        ({ valid, errors }) => {
          if (valid) {
            callback()
          } else {
            callback(errors[0].message)
          }
        }
      )
    },
    formSubmit () {
      window.__MICRO_ROOT__?.api?.track?.('ticketcheck_search')
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.isSearch = true
          this.loading = true
          this.list = []
          this.segment = []
          try {
            const data = await queryTicketInfo(values)
            this.loading = false
            this.$refs.imgcaptcha.refresh()
            const { segment, ...restInfo } = data || {}
            this.list.push(restInfo)
            this.segment = segment
            window.__MICRO_ROOT__?.api?.track?.('ticketcheck_succeed')
          } catch (e) {
            this.loading = false
            this.$refs.imgcaptcha.refresh()
            this.$message.error(e.message)
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
#ticket-verify {
  ::v-deep .ant-form-explain {
    margin-top: 0;
  }
  .header {
    border-bottom: 1px solid @primary-color;
  }
  .loading {
    width: 100%;
    text-align: center;
  }
  .mod-wrap {
    padding: 70px 0;
    display: flex;
    .block {
      padding: 0 40px;
      width: 50%;
    }
    .form {
      border-right: 1px solid #eee;
    }
    .submit-btn.ant-btn {
      width: 100%;
    }
  }
  .table-wrap {
    padding-bottom: 100px;

    .table-head {
      line-height: 20px;
      border-left: 4px solid @primary-color;
      padding-left: 12px;
      margin: 20px 0;
    }
  }
  ::v-deep .ant-descriptions {
    .ant-descriptions-item-no-label {
      display: none;
    }
    .result {
      text-align: center;
      font-weight: bold;
    }
  }
}
</style>
